import * as utils from '../../utils';
import { ACTIONS, COMPACT_LIMIT, SCENE_BASE } from '../../constants';

const initState = {
  compact: false, // for compact (mobile + small screen) scene view
  width: utils.getWinWidth(),
  height: utils.getWinHeight(),
  scale: 1,
  fullscreen: false,
};

const getScale = (width, height) => {
  const sX = width / SCENE_BASE.WIDTH;
  const sY = height / SCENE_BASE.HEIGHT;
  return Math.min(sX, sY);
};

const ui = (state = initState, action) => {
  switch (action.type) {
    case ACTIONS.RESIZE:
      return {
        ...state,
        compact: action.width < COMPACT_LIMIT,
        width: action.width,
        height: action.height,
        scale: getScale(action.width, action.height),
      };
    case ACTIONS.SET_FULLSCREEN:
      return {
        ...state,
        fullscreen: action.fsState,
      };
    default:
      return state;
  }
};

export default ui;



// WEBPACK FOOTER //
// ./src/redux/reducers/ui.js